import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { Tabs, DealerSearchBoxNZ } from "components"
import { withRadium } from "higher-order-components"

class SearchSectionMapLocationContainer extends PureComponent {
  render() {
    return (
      <div>
        {!this.props.disableFilters && (
          <div style={styles.checkboxes}>
            <Tabs
              compact
              divider
              options={this.props.filters.map(filter => ({
                ...filter,
                label: filter.name
              }))}
              onChange={this.props.handleToggleFilter}
              active={this.props.activeIndex}
              style={styles.radioGroup} />
          </div>
        )}
        <div style={styles.dealerBoxContainer}>
          <DealerSearchBoxNZ
            searchOverride={this.props.searchOverride || ""}
            dealerSearchEndPoint={this.props.dealerSearchEndPoint}
            onChange={this.props.updateLocationInSearchInput}
            componentRestrictions={{ country: 'nz' } // handleAutocomplete
            }
            updateLocations={this.props.updateLocationInSearchInput}
            gtmMapping={this.props.gtmMapping}
            handleNZLocations={this.props.handleNZLocations} />
        </div>
      </div>
    )
  }
}

SearchSectionMapLocationContainer.propTypes = {
  dealerSearchEndPoint: PropTypes.string,
  searchOverride: PropTypes.string,
  disableFilters: PropTypes.bool,
  activeIndex: PropTypes.number,
  updateLocationInSearchInput: PropTypes.func,
  handleToggleFilter: PropTypes.func,
  filters: PropTypes.array,
  gtmMapping: PropTypes.object
}

const styles = {
  checkboxes: {
    fontSize: "70%",
    margin: "1.8em auto"
  },
  dealerBoxContainer: {
    width: "80%",
    margin: "1.8em auto",
    boxSizing: "border-box",
    maxWidth: "30em"
  },
  radioGroup: {
    letterSpacing: "0.2em",
    textTransform: "uppercase",
    fontSize: "80%"
  }
}

export default withRadium()(SearchSectionMapLocationContainer)



// WEBPACK FOOTER //
// ./src/containers/map-location/search-section.jsx